"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ = require("../..");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var IconButton = exports.IconButton = (0, _styledComponents["default"])(_.Button).withConfig({
  displayName: "IconButtonstyle__IconButton",
  componentId: "sc-1kle7rq-0"
})(function (_ref) {
  var small = _ref.small,
    large = _ref.large;
  var size = function size() {
    if (small) {
      return 36;
    }
    if (large) {
      return 60;
    }
    return 48;
  };
  return {
    borderRadius: '50%',
    padding: 0,
    lineHeight: 0,
    minHeight: size(),
    minWidth: size(),
    svg: {
      fontSize: size(),
      boxSizing: 'border-box',
      padding: '26%',
      position: 'relative',
      top: '0'
    }
  };
});